import React, { useState, useEffect } from "react";
import { FAQ_ITEMS } from "../../data/faqItems";
import { useDocMeta } from "../../lib/useDocMeta";
import { track, EVENT } from "../../lib/publicAnalytics";
import { ChevronDown } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  useDocMeta({
    title: "FAQ · GovBidIQ",
    description: "Frequently asked questions about GovBidIQ — who it's for, what's included, and what private vs. public users can access.",
    path: "/faq",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });
  useEffect(() => { track(EVENT.FAQ_VIEWED, {}); }, []);

  return (
    <div className="max-w-[860px] mx-auto px-6 py-14">
      <div className="font-mono text-[10px] tracking-widest uppercase text-sky-400 mb-3">/ FAQ</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl text-slate-100 leading-tight mb-3">Frequently asked.</h1>
      <p className="text-slate-400 text-lg leading-relaxed mb-10">Straight answers — what GovBidIQ is, who it serves, and how your data stays private.</p>

      <div className="border-t border-[var(--border-soft)]">
        {FAQ_ITEMS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="border-b border-[var(--border-soft)]" data-testid={`faq-item-${i}`}>
              <button onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} className="w-full py-4 text-left flex items-center justify-between gap-4 group">
                <span className="font-display font-bold text-slate-100 text-base group-hover:text-sky-300">{f.q}</span>
                <ChevronDown className={`w-4 h-4 text-slate-500 shrink-0 transition-transform ${isOpen ? "rotate-180 text-sky-400" : ""}`} />
              </button>
              {isOpen && <p className="text-slate-300 text-sm leading-relaxed pb-5 max-w-3xl">{f.a}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
